import React, { useState, useEffect } from 'react';
import styles from '../Point.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import useOnScreen from '../../../hooks/useOnScreen';
import ContentSpinner from '../../shared/Spinner/Spinner';
import Filters from './Filters/Filters';
import Table from './Table/Table';
import { VOUCHER_FILTER_PERIODS, VOUCHERS_PAGE_SIZE } from '../../../constants/defaultValues';
import { clearVouchers, getVouchers } from '../../../store/actions/vouchers';
import { useEffectSkipFirst } from '../../../hooks/useEffectSkipFirst';

const initialFilters = {
    status: 0,
    period: VOUCHER_FILTER_PERIODS[0],
    pageOffset: 0,
};

const Vouchers = () => {
    const dispatch = useDispatch();
    const { data, loading, hasMore } = useSelector(state => state.vouchers);
    const { ref, isIntersecting: isVisible } = useOnScreen();

    const [filters, setFilters] = useState(initialFilters);

    const clearData = () => {
        dispatch(clearVouchers());
    };

    useEffect(() => {
        dispatch(getVouchers(filters));

        return () => {
            clearData();
        };
    }, []);

    useEffect(() => {
        if (!loading && isVisible && hasMore) {
            setVoucherFilters(filters => ({
                ...filters,
                pageOffset: filters.pageOffset + VOUCHERS_PAGE_SIZE,
            }));
        }
    }, [isVisible]);

    useEffectSkipFirst(() => {
        const { runSearch, ...otherFilters } = filters;

        if (runSearch) {
            dispatch(getVouchers(otherFilters));
        }
    }, [filters]);

    const setVoucherFilters = (updater, options = {}) => {
        const { runSearch = true } = options;

        setFilters(filters => ({ ...updater(filters), runSearch }));
    };

    const onSearch = () => {
        setVoucherFilters(filters => ({
            ...filters,
            pageOffset: 0,
        }));
    };

    return (
        <>
            <Filters
                filters={filters}
                setFilters={setVoucherFilters}
                onSearch={onSearch}
                clearData={clearData}
            />
            <main className={styles.main} style={{ height: 'calc(100% - 202px)' }}>
                {loading && <ContentSpinner />}
                {data.length > 0 && <Table vouchers={data} />}
                <button className={'v-hidden h-0'} ref={ref}>
                    Load More
                </button>
            </main>
        </>
    );
};

export default Vouchers;
